import React from 'react';
import PropTypes from 'prop-types';
import { LocaleService } from '@sm360/widget-commons-core-services';

import 'commons-general/components/ModalCloseButton/ModalCloseButton.scss';

const ModalCloseButton = ({ closeAction, dataTestPrefix }) => (
    <button
        className="sr-modal__close is-uppercase"
        onClick={closeAction}
        data-test={dataTestPrefix ? `${dataTestPrefix}.modal-close-button` : 'modal-close-button'}
    >
        {LocaleService.t('COMMONS_GENERAL.MODAL.CLOSE')} <icon className="icon-X-rouge" />
    </button>
);

ModalCloseButton.displayName = 'ModalCloseButton';

ModalCloseButton.defaultProps = {
    dataTestPrefix: '',
};

ModalCloseButton.propTypes = {
    closeAction: PropTypes.func.isRequired,
    dataTestPrefix: PropTypes.string,
};
export default ModalCloseButton;
